import { render } from "./RequirementReply.vue?vue&type=template&id=4286f9b6&scoped=true"
import script from "./RequirementReply.vue?vue&type=script&lang=js"
export * from "./RequirementReply.vue?vue&type=script&lang=js"

import "./RequirementReply.vue?vue&type=style&index=0&id=4286f9b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4286f9b6"]])

export default __exports__